// Mirrors IPC.Common/Utils/YoutubeUtil.cs on the API; keep the accepted formats identical.
const VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;
const WATCH_HOSTS = ['youtube.com', 'www.youtube.com', 'm.youtube.com'];
const PATH_PREFIXES = ['shorts', 'live', 'embed'];

export function parseYoutubeId(url) {
    if (!url || !url.trim()) {
        return null;
    }

    let raw = url.trim();
    if (!raw.includes('://')) {
        raw = `https://${raw}`;
    }

    let parsed;
    try {
        parsed = new URL(raw);
    } catch (e) {
        return null;
    }

    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
        return null;
    }

    const host = parsed.hostname.toLowerCase();
    const segments = parsed.pathname.split('/').filter(Boolean);
    let candidate = null;

    if (host === 'youtu.be' || host === 'www.youtu.be') {
        candidate = segments.length === 1 ? segments[0] : null;
    } else if (WATCH_HOSTS.includes(host)) {
        if (segments.length === 1 && segments[0] === 'watch') {
            candidate = parsed.searchParams.get('v');
        } else if (segments.length === 2 && PATH_PREFIXES.includes(segments[0])) {
            candidate = segments[1];
        }
    }

    return candidate && VIDEO_ID_PATTERN.test(candidate) ? candidate : null;
}

export function youtubeThumbnailUrl(videoId) {
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
}

export function youtubeEmbedUrl(videoId) {
    return `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;
}

/**
 * Title from YouTube's public oEmbed endpoint, or null. Used only to pre-fill the form,
 * so any failure (private video, network, CORS) is swallowed and the admin types it instead.
 */
export async function fetchYoutubeTitle(videoId) {
    const watchUrl = `https://www.youtube.com/watch?v=${videoId}`;
    try {
        const response = await fetch(`https://www.youtube.com/oembed?format=json&url=${encodeURIComponent(watchUrl)}`);
        if (!response.ok) {
            return null;
        }
        const data = await response.json();
        return data.title || null;
    } catch (e) {
        return null;
    }
}
